import { userSettingsStore } from '@pascal/pascal-core/shared/core/store';

import { soundService } from '../../module/services/SoundService';
import { gameName } from '../../enums/gameConfigsAndUrls';

userSettingsStore.localStorageAndUserSettingsInit({ gameName, soundService: soundService });
